export default "__VITE_ASSET__Bp9b0ovv__"